import React from 'react';
import PropTypes from 'prop-types';

const withValidateOnSelectHOCGenerator = (Component) => {
  function WithValidateOnSelectHOC(props) {
    const { inputValue, resetInputValue, multiInputValidateOnSelect, multiInputOnSelect, setValidationMessage, values } = props;

    const announceAdded = () => {
      const count = (values?.length ?? 0) + 1;
      setValidationMessage('');
      setTimeout(() => {
        setValidationMessage(`Email address added. ${count} email${count === 1 ? '' : 's'} in the list.`);
      }, 0);
    };

    const validateOnSelect = () => {
      if (multiInputValidateOnSelect) {
        const { isValid, validationMessage } = multiInputValidateOnSelect(inputValue);

        if (isValid) {
          multiInputOnSelect(inputValue);
          resetInputValue();
          announceAdded();
        } else {
          setValidationMessage(validationMessage);
        }
      } else {
        multiInputOnSelect(inputValue);
        resetInputValue();
        announceAdded();
      }
    };

    return <Component {...props} validateOnSelect={validateOnSelect} />;
  }

  WithValidateOnSelectHOC.propTypes = {
    inputValue: PropTypes.string,
    resetInputValue: PropTypes.func,
    multiInputValidateOnSelect: PropTypes.func,
    multiInputOnSelect: PropTypes.func,
    setValidationMessage: PropTypes.func,
    values: PropTypes.array,
  };

  return WithValidateOnSelectHOC;
};

const withValidateOnSelect = () => (Component) => withValidateOnSelectHOCGenerator(Component);

export default withValidateOnSelect;
